var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.214 8.836H11.5c-.197 0-.236-.139-.236-.336V1.786C11.264.8 10.986 0 10 0S8.764.8 8.764 1.786V8.5c0 .197-.18.336-.377.336H1.786C.8 8.836 0 9.014 0 10s.8 1.204 1.786 1.204h6.6a.39.39 0 01.378.375v6.635C8.764 19.2 9.014 20 10 20s1.264-.652 1.264-1.638v-6.783c0-.197.039-.375.236-.375h6.714C19.2 11.204 20 10.986 20 10s-.8-1.164-1.786-1.164z",
    fill: "#8392A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusGray);
export default __webpack_public_path__ + "static/media/ic-plus_gray.84c976abc50865a779a3157f7ed80831.svg";
export { ForwardRef as ReactComponent };